/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Loginheadertitle2Inputs */

const en_auth_loginheadertitle2 = /** @type {(inputs: Auth_Loginheadertitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client Experience Platform`)
};

/**
* | output |
* | --- |
* | "Client Experience Platform" |
*
* @param {Auth_Loginheadertitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const auth_loginheadertitle2 = /** @type {((inputs?: Auth_Loginheadertitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Loginheadertitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_loginheadertitle2(inputs)
});
export { auth_loginheadertitle2 as "auth_loginHeaderTitle" }